"use strict";

import { useEffect } from 'react';
import { loadState } from '../utils';
import { createAction } from './useDistributedState';
import { jsx as _jsx } from "react/jsx-runtime";
export const providerFactory = ({
  stateContext,
  state,
  updateState,
  channelRef,
  userId,
  channelName,
  storageType,
  dispatchAction,
  initialisedRef
}) => ({
  children
}) => {
  useEffect(() => {
    const handleEvent = event => {
      dispatchAction(event.data);
    };
    channelRef.current.addEventListener('message', handleEvent);
    return () => channelRef.current.removeEventListener('message', handleEvent);
  }, [channelRef.current]);
  useEffect(() => {
    if (initialisedRef.current) {
      return;
    }
    initialisedRef.current = true;
    const savedState = loadState({
      key: channelName,
      uniqueId: userId,
      storageType
    });
    if (savedState) {
      const action = createAction('UPDATE_STATE', savedState);
      dispatchAction(action);
    }
  }, []);
  return /*#__PURE__*/_jsx(stateContext.Provider, {
    value: {
      state,
      updateState
    },
    children: children
  });
};